import { createAsyncAction } from 'typesafe-actions';
import { GetAppsRequest, GetAppsResponse } from './types';
import { ResponseError } from 'api';

export const apps = createAsyncAction(
  'GET_APPS_REQUEST',
  'GET_APPS_SUCCESS',
  'GET_APPS_ERROR',
)<GetAppsRequest, GetAppsResponse, ResponseError>();
